/**
 * Utilitas bersama grafik telemetry (tab Detail Stasiun).
 * Harus dimuat sebelum detail-station-*-telemetry*.min.js
 */
(function (global) {
  'use strict';

  /**
   * Format angka untuk tooltip: bilangan bulat tanpa desimal;
   * jika ada pecahan, paling banyak 3 digit di belakang koma (dibulatkan),
   * trailing zero dibuang.
   */
  function formatTelemetryTooltipNumber(value) {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    var n = Number(value);
    if (!Number.isFinite(n)) {
      return String(value);
    }
    return n.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3,
    });
  }

  /**
   * Sumbu Y dari data { y } + padding; memaksa rentang minimum vs skala nilai
   * supaya variasi kecil tidak "pipih" ketika min/max auto Highcharts terlalu lebar.
   */
  function computeTelemetryAxisMinMaxFromYValues(points, options) {
    options = options || {};
    var padRatio = options.padRatio != null ? options.padRatio : 0.1;
    var minRangeVsScale =
      options.minRangeVsScale != null ? options.minRangeVsScale : 0.03;

    var ys = [];
    var i;
    var y;
    for (i = 0; i < points.length; i++) {
      y =
        points[i] != null && typeof points[i].y === 'number'
          ? points[i].y
          : Number.NaN;
      if (Number.isFinite(y)) {
        ys.push(y);
      }
    }
    if (!ys.length) {
      return null;
    }

    var lo = Math.min.apply(null, ys);
    var hi = Math.max.apply(null, ys);
    var span = hi - lo;
    var scaleRef = Math.max(Math.abs(lo), Math.abs(hi), 1e-12);

    var pad = span > 0 ? span * padRatio : scaleRef * padRatio;
    var rangeWithPad = span + 2 * pad;
    var minRange = Math.max(scaleRef * minRangeVsScale, span > 0 ? span * 0.15 : 0);
    var totalRange = Math.max(rangeWithPad, minRange);

    var mid = (lo + hi) / 2;
    return {
      min: mid - totalRange / 2,
      max: mid + totalRange / 2,
    };
  }

  global.formatTelemetryTooltipNumber = formatTelemetryTooltipNumber;
  global.computeTelemetryAxisMinMaxFromYValues =
    computeTelemetryAxisMinMaxFromYValues;

  /**
   * Guard untuk load grafik telemetry: batalkan XHR sebelumnya dan abaikan callback
   * jika sudah ada permintaan lebih baru (hindari grafik kosong / race saat ganti waktu/sensor).
   */
  function createTelemetryChartLoadGuard() {
    var seq = 0;
    var activeXhr = null;

    return {
      start: function () {
        seq += 1;
        var token = seq;
        if (activeXhr && typeof activeXhr.abort === 'function') {
          try {
            activeXhr.abort();
          } catch (ignore) {}
        }
        activeXhr = null;

        return {
          isCurrent: function () {
            return token === seq;
          },
          register: function (jqXHR) {
            if (jqXHR && token === seq) {
              activeXhr = jqXHR;
            }
          },
          clearIfCurrent: function () {
            if (token === seq) {
              activeXhr = null;
            }
          },
        };
      },
    };
  }

  global.createTelemetryChartLoadGuard = createTelemetryChartLoadGuard;

  /**
   * Jumlah sumbu x/y dari opsi Highcharts (undefined = 1 sumbu default).
   */
  function countHighchartsAxes(axisConfig) {
    if (axisConfig === false) {
      return 0;
    }
    if (axisConfig == null) {
      return 1;
    }
    if (Array.isArray(axisConfig)) {
      return axisConfig.length > 0 ? axisConfig.length : 1;
    }
    return 1;
  }

  /**
   * Buang seri yang mereferensikan xAxis/yAxis index di luar jumlah sumbu yang
   * didefinisikan — cegah error Highcharts "axis that does not exist".
   */
  function sanitizeHighchartsAxisRefs(chartOptions) {
    if (!chartOptions || typeof chartOptions !== 'object') {
      return chartOptions;
    }

    var xCount = countHighchartsAxes(chartOptions.xAxis);
    var yCount = countHighchartsAxes(chartOptions.yAxis);

    function isValidAxisIndex(index, count) {
      return (
        typeof index === 'number' &&
        Number.isFinite(index) &&
        index >= 0 &&
        index < count
      );
    }

    if (!Array.isArray(chartOptions.series)) {
      return chartOptions;
    }

    chartOptions.series = chartOptions.series.filter(function (series) {
      if (!series || typeof series !== 'object') {
        return true;
      }
      if (
        typeof series.xAxis === 'number' &&
        !isValidAxisIndex(series.xAxis, xCount)
      ) {
        return false;
      }
      if (
        typeof series.yAxis === 'number' &&
        !isValidAxisIndex(series.yAxis, yCount)
      ) {
        return false;
      }
      return true;
    });

    return chartOptions;
  }

  function createTelemetryHighchartsChart(renderTo, options, callback) {
    sanitizeHighchartsAxisRefs(options);
    if (typeof global.Highcharts === 'undefined') {
      return null;
    }
    if (typeof callback === 'function') {
      return global.Highcharts.chart(renderTo, options, callback);
    }
    return global.Highcharts.chart(renderTo, options);
  }

  function patchHighchartsAxisSanitizer() {
    if (
      typeof global.Highcharts === 'undefined' ||
      global.Highcharts.__telemetryAxisSanitizePatched
    ) {
      return;
    }

    function wrapChartMethod(original) {
      return function (renderTo, options, callback) {
        if (options && typeof options === 'object') {
          sanitizeHighchartsAxisRefs(options);
        }
        return original.call(this, renderTo, options, callback);
      };
    }

    if (typeof global.Highcharts.chart === 'function') {
      global.Highcharts.chart = wrapChartMethod(global.Highcharts.chart);
    }
    if (typeof global.Highcharts.stockChart === 'function') {
      global.Highcharts.stockChart = wrapChartMethod(
        global.Highcharts.stockChart,
      );
    }

    global.Highcharts.__telemetryAxisSanitizePatched = true;
  }

  global.countHighchartsAxes = countHighchartsAxes;
  global.sanitizeHighchartsAxisRefs = sanitizeHighchartsAxisRefs;
  global.createTelemetryHighchartsChart = createTelemetryHighchartsChart;
  global.patchHighchartsAxisSanitizer = patchHighchartsAxisSanitizer;

  function getTelemetryStationId() {
    var fromHidden = ($('#station-id').val() || '').trim();
    if (fromHidden) {
      return fromHidden;
    }
    if (typeof stationId !== 'undefined' && stationId) {
      return String(stationId);
    }
    return '';
  }

  global.getTelemetryStationId = getTelemetryStationId;

  function thresholdValueOf(series) {
    var custom = series && series.options && series.options.custom;
    var value = custom ? Number(custom.thresholdValue) : NaN;
    if (!Number.isFinite(value) && series && series.yData && series.yData.length) {
      value = Number(series.yData[0]);
    }
    return value;
  }

  function isThresholdSeries(series, axis) {
    var custom = series && series.options && series.options.custom;
    return !!(
      series &&
      series.visible &&
      custom &&
      custom.axisRole === 'threshold' &&
      (!axis || series.yAxis === axis)
    );
  }

  /**
   * Sumbu Y grafik PDA/AWLR dikunci ke rentang data. Garis ambang yang
   * awalnya hidden (di luar rentang) tetap ter-clip saat legend di-show.
   * Panggil dari event show/hide series, sebelum redraw bawaan setVisible.
   *
   * chart.__thresholdAxisBase = {
   *   fitting: false,
   *   axes: [{ axisIndex, min, max, syncFloor, followAxisIndex }]
   * }
   *
   * @return {boolean} true jika ekstrem sumbu berubah
   */
  function fitChartAxesToVisibleThresholds(hcChart, redraw) {
    var base = hcChart && hcChart.__thresholdAxisBase;
    if (!base || base.fitting || !base.axes || !base.axes.length) {
      return false;
    }

    base.fitting = true;
    var changed = false;
    var applied = {};

    function nearlyEqual(a, b) {
      return Number.isFinite(a) && Number.isFinite(b) && Math.abs(a - b) < 1e-6;
    }

    function applyExtremes(axis, axisMin, axisMax, syncFloor) {
      if (!axis || !(axisMax > axisMin)) {
        return null;
      }
      if (nearlyEqual(axis.min, axisMin) && nearlyEqual(axis.max, axisMax)) {
        return { min: axisMin, max: axisMax };
      }
      if (syncFloor) {
        axis.options.floor = axisMin;
        if (axis.userOptions) {
          axis.userOptions.floor = axisMin;
        }
      }
      axis.setExtremes(axisMin, axisMax, false, false);
      changed = true;
      return { min: axisMin, max: axisMax };
    }

    try {
      var i;
      for (i = 0; i < base.axes.length; i++) {
        var spec = base.axes[i];
        if (spec.followAxisIndex != null) {
          continue;
        }
        var axis = hcChart.yAxis[spec.axisIndex];
        if (!axis || !Number.isFinite(spec.min) || !Number.isFinite(spec.max)) {
          continue;
        }

        var min = spec.min;
        var max = spec.max;
        hcChart.series.forEach(function (series) {
          if (!isThresholdSeries(series, axis)) {
            return;
          }
          var value = thresholdValueOf(series);
          if (!Number.isFinite(value)) {
            return;
          }
          if (value < min) {
            min = value;
          }
          if (value > max) {
            max = value;
          }
        });

        var pad = 0;
        if (min < spec.min || max > spec.max) {
          var span = Math.max(max - min, 0);
          pad = span > 0 ? Math.max(span * 0.08, 0.05) : 0.1;
        }
        var axisMin = min < spec.min ? min - pad : spec.min;
        var axisMax = max > spec.max ? max + pad : spec.max;
        applied[spec.axisIndex] = applyExtremes(
          axis,
          axisMin,
          axisMax,
          !!spec.syncFloor,
        ) || { min: axis.min, max: axis.max };
      }

      for (i = 0; i < base.axes.length; i++) {
        var follow = base.axes[i];
        if (follow.followAxisIndex == null) {
          continue;
        }
        var leaderSpec = null;
        var s;
        for (s = 0; s < base.axes.length; s++) {
          if (base.axes[s].axisIndex === follow.followAxisIndex) {
            leaderSpec = base.axes[s];
            break;
          }
        }
        var leaderApplied = applied[follow.followAxisIndex];
        var followAxis = hcChart.yAxis[follow.axisIndex];
        if (
          !leaderSpec ||
          !leaderApplied ||
          !followAxis ||
          !Number.isFinite(follow.min) ||
          !Number.isFinite(follow.max)
        ) {
          continue;
        }
        applyExtremes(
          followAxis,
          follow.min + (leaderApplied.min - leaderSpec.min),
          follow.max + (leaderApplied.max - leaderSpec.max),
          false,
        );
      }
    } finally {
      base.fitting = false;
    }

    if (redraw && changed) {
      hcChart.redraw(false);
    }
    return changed;
  }

  function onThresholdSeriesVisibility() {
    fitChartAxesToVisibleThresholds(this.chart, false);
  }

  global.fitChartAxesToVisibleThresholds = fitChartAxesToVisibleThresholds;
  global.onThresholdSeriesVisibility = onThresholdSeriesVisibility;

  /**
   * Telemetry is light-theme only: ignore OS prefers-color-scheme for Highcharts.
   * Load after highstock.js / highcharts.js.
   */
  function applyHighchartsLightTheme() {
    if (typeof global.Highcharts === 'undefined' || !global.Highcharts.setOptions) {
      return;
    }

    global.Highcharts.setOptions({
      colorScheme: 'light',
      chart: {
        backgroundColor: '#ffffff',
        plotBackgroundColor: '#ffffff',
      },
      xAxis: {
        gridLineWidth: 0,
      },
      yAxis: {
        gridLineWidth: 0,
        minorGridLineWidth: 0,
      },
    });
  }

  applyHighchartsLightTheme();
  global.applyHighchartsLightTheme = applyHighchartsLightTheme;
  patchHighchartsAxisSanitizer();
})(typeof window !== 'undefined' ? window : this);
